export default __webpack_public_path__ + "static/media/file-material.5abdfb9f.png";